import React, { useEffect, useState } from "react";
import api, { formatApiError, uploadFile, fileUrl } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ADMIN } from "@/lib/nav";
import { toast } from "sonner";
import { Upload, Save } from "lucide-react";

function ProfilByRolePage({ role, title }) {
  const [form, setForm] = useState({ nama: "", tempat_lahir: "", tanggal_lahir: "", niy: "", alamat: "", telp: "", foto_file_id: null });
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/admin/profil/${role}`);
        setForm({
          nama: data.nama || "", tempat_lahir: data.tempat_lahir || "",
          tanggal_lahir: data.tanggal_lahir || "", niy: data.niy || "",
          alamat: data.alamat || "", telp: data.telp || "",
          foto_file_id: data.foto_file_id || null,
        });
      } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    })();
  }, [role]);

  const handleUpload = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    setUploading(true);
    try { const res = await uploadFile(f); setForm({ ...form, foto_file_id: res.id }); toast.success("Foto diunggah"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setUploading(false); }
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await api.put(`/admin/profil/${role}`, form); toast.success("Profil disimpan"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Layout nav={NAV_ADMIN}>
      <PageTitle title={title} />
      <section className="pp-card p-6 sm:p-8">
        <div className="flex flex-col sm:flex-row items-start gap-6 mb-6">
          {form.foto_file_id ? (
            <img src={fileUrl(form.foto_file_id)} alt="Foto" className="w-36 h-36 rounded-xl object-cover border border-slate-200" />
          ) : (
            <div className="w-36 h-36 rounded-xl bg-slate-100 flex items-center justify-center text-slate-300 text-5xl font-bold">{(form.nama || "?")[0]}</div>
          )}
          <div className="flex-1">
            <h3 className="text-xl font-bold text-slate-900">{form.nama || "—"}</h3>
            <p className="text-slate-500 capitalize">{role.replace("_", " ")}</p>
            <label className="pp-btn-secondary cursor-pointer mt-4">
              <Upload className="w-4 h-4" /> {uploading ? "Mengunggah…" : "Ganti Foto"}
              <input type="file" accept="image/*" onChange={handleUpload} className="hidden" />
            </label>
          </div>
        </div>
        <form onSubmit={save} className="grid sm:grid-cols-2 gap-4 pt-6 border-t border-slate-200">
          <div><label className="pp-label">Nama Lengkap</label><input data-testid="profil-nama" className="pp-input" value={form.nama} onChange={(e) => setForm({...form, nama: e.target.value})} /></div>
          <div><label className="pp-label">NIY</label><input data-testid="profil-niy" className="pp-input" value={form.niy} onChange={(e) => setForm({...form, niy: e.target.value})} /></div>
          <div><label className="pp-label">Tempat Lahir</label><input className="pp-input" value={form.tempat_lahir} onChange={(e) => setForm({...form, tempat_lahir: e.target.value})} /></div>
          <div><label className="pp-label">Tanggal Lahir</label><input type="date" className="pp-input" value={form.tanggal_lahir || ""} onChange={(e) => setForm({...form, tanggal_lahir: e.target.value})} /></div>
          <div><label className="pp-label">No. Telp</label><input data-testid="profil-telp" className="pp-input" value={form.telp} onChange={(e) => setForm({...form, telp: e.target.value})} /></div>
          <div className="sm:col-span-2"><label className="pp-label">Alamat</label><textarea rows={2} className="pp-input" value={form.alamat} onChange={(e) => setForm({...form, alamat: e.target.value})} /></div>
          <div className="sm:col-span-2 flex justify-end">
            <button type="submit" disabled={saving} className="pp-btn-primary" data-testid="profil-submit"><Save className="w-4 h-4" />{saving ? "Menyimpan…" : "Simpan Profil"}</button>
          </div>
        </form>
      </section>
    </Layout>
  );
}

export function ProfilKepsekAdmin() { return <ProfilByRolePage role="kepala_sekolah" title="Profil Kepala Sekolah" />; }
export function ProfilPustakaAdmin() { return <ProfilByRolePage role="pustaka" title="Profil Petugas Pustaka" />; }
export function ProfilBendaharaAdmin() { return <ProfilByRolePage role="bendahara" title="Profil Bendahara" />; }
